/**
 * Désactive le bouton submit d'un formulaire (ui:form-shell) tant que ses champs obligatoires ne
 * sont pas remplis. Prend en compte [required] ET [data-required] — ce dernier pour les champs
 * CACHÉS obligatoires (ex. latitude/longitude remplis par l'autocomplétion de ville), que la
 * validation native ignore. L'autocomplétion émet un `change` sur ces champs pour réévaluer.
 */
function evaluate(form, submits) {
    const fields = form.querySelectorAll('[required], [data-required]');
    let complete = true;
    fields.forEach((field) => {
        if (!String(field.value || '').trim()) complete = false;
    });
    submits.forEach((submit) => { submit.disabled = !complete; });
}

function attach(shell) {
    const form = shell.querySelector('form');
    if (!form) return;
    // TOUS les boutons de soumission du formulaire, et pas seulement celui de l'enveloppe : un
    // formulaire qui offre plusieurs gestes de même rang porte les siens dans son corps
    // (ui:form-shell hideSubmit), et le garde ne trouvait alors rien à fermer — il rendait la main
    // sans rien dire, laissant soumettre un formulaire incomplet par les seuls boutons qui existent.
    // `[data-locked]` reste EN DEHORS : ce garde-là ne connaît qu'une raison de fermer un bouton,
    // la complétude du formulaire, et il rouvrait donc ceux que la vue avait fermés pour une autre
    // — le bouton du mois déjà affiché, sur les landings mensuelles, redevenait cliquable dès que
    // la ville était remplie, c'est-à-dire toujours puisqu'une réponse la reporte.
    const submits = [...form.querySelectorAll('button[type="submit"]:not([data-locked])')];
    if (!submits.length) return;
    const run = () => evaluate(form, submits);
    form.addEventListener('input', run);
    form.addEventListener('change', run);
    run();
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.ui-form').forEach(attach);
});
